<template>
  <div v-loading="loading">

    <Head />
    <div class="body">
      <!-- 状态切换 -->
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="search">
          <!--  全部-->
          <!-- <el-tab-pane :label="$t('message.allStatus')" name="0"></el-tab-pane> -->
          <!--  其他状态-->
          <el-tab-pane v-for="item in tabsList" :key="item.id" :label="item.name" :name="item.id + ''"></el-tab-pane>
        </el-tabs>
        <!-- 采购状态筛选 -->
        <div class="btn" v-if="userRole == 2">
          <!-- 待采购审核 -->
          <el-button :type="datas.refund_status == 1 ? 'primary' : 'info'" @click="procurementReview(1)">
            {{ $t('message.pendingProcurementReview') }}
          </el-button>
          <!-- 已审核 -->
          <el-button :type="datas.refund_status == 10 ? 'primary' : 'info'" @click="procurementReview(10)">
            {{ $t('message.reviewed') }}
          </el-button>
        </div>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <!-- 搜索 -->
        <div class="Container">
          <el-date-picker v-model="datas.dateStart" type="date" value-format="yyyy-MM-dd" clearable
            :placeholder="$t('message.startDateTC')">
          </el-date-picker>
        </div>
        <div class="Container">
          <el-date-picker v-model="datas.dateEnd" type="date" :placeholder="$t('message.dateClosedTC')"
            value-format="yyyy-MM-dd" clearable>
          </el-date-picker>
        </div>
        <!-- 物流号 -->
        <div class="Container">
          <el-input v-model="datas.express_no" clearable :placeholder="$t('message.pleaseEnterTheLogisticsNumber')"
            onfocus="this.select()"></el-input>
        </div>
        <!-- 交易号 -->
        <div class="Container">
          <el-input v-model="datas.purchase_no" clearable :placeholder="$t('message.pleaseEnterTransactionNumber')"
            onfocus="this.select()"></el-input>
        </div>
        <!-- 订单号 -->
        <div class="Container">
          <el-input v-model="datas.order_sn" clearable :placeholder="$t('message.orderNumber')"
            onfocus="this.select()"></el-input>
        </div>
        <!-- 商品管理番号 -->
        <div class="Container">
          <el-input v-model="datas.for_sn" clearable :placeholder="$t('message.productManagementNumber')"
            onfocus="this.select()"></el-input>
        </div>
        <!-- 客户ID -->
        <div class="Container">
          <el-input v-model="datas.user_id" clearable :placeholder="$t('message.userID')"
            onfocus="this.select()"></el-input>
        </div>
        <!-- 客户ID -->
        <div class="Container">
          <el-input v-model="datas.realname" clearable :placeholder="$t('message.userName')"
            onfocus="this.select()"></el-input>
        </div>
        <!-- 问题产品类别 -->
        <div class="Container">
          <el-select v-model="datas.type" placeholder="问题产品类别" filterable clearable>
            <el-option v-for="item in problemTypes" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!--采购处理类别筛选  -->
        <div class="Container">
          <el-select v-model="datas.g_deal_type" placeholder="采购处理类别筛选" filterable clearable>
            <el-option v-for="(item, index) in g_deal_type" :key="index" :label="item.key" :value="item.key">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <!-- 退换货物流号 -->
        <div class="Container">
          <el-input v-model="datas.refund_express_no" clearable
            :placeholder="$t('message.returnAndExchangeLogisticsNumber')" onfocus="this.select()"></el-input>
        </div>
        <!--人员范围-->
        <div class="Container">
          <!--  人员范围-->
          <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
        </div>
        <!--  全体人员-->
        <div class="Container">
          <el-select v-model="datas.admin_id" :placeholder="$t('message.specificPersonnel')" filterable clearable>
            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 采购 -->
        <div class="Container">
          <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>

        <!-- 业务 -->
        <div class="Container">
          <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
            <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 配货员 -->
        <div class="Container">
          <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 是否紧急 -->
        <div class="Container"
          v-if="datas.status == '1' || datas.status == '2' || datas.status == '3' || datas.status == '4'">
          <el-select v-model="datas.overdue" :placeholder="$t('message.isOverdue')" filterable clearable
            @change="$forceUpdate()">
            <el-option :label="$t('message.all')" value="0">
            </el-option>
            <el-option :label="$t('message.overdue')" value="1">
            </el-option>
          </el-select>
        </div>
        <!-- 客户属性 -->
        <div class="Container">
          <el-select v-model="datas.attribute" clearable filterable :placeholder="$t('message.customerProperty')">
            <el-option v-for="item in vipList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 有无退款凭证 -->
        <div class="Container">
          <el-select v-model="datas.refund_image" clearable filterable :placeholder="$t('message.isRefundVoucher')">
            <el-option label="有退款凭证" value="1">
            </el-option>
            <el-option label="无退款凭证" value="2">
            </el-option>
          </el-select>
        </div>
        <div class="btn">
          <!--  搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
          <!--  重置 -->
          <el-button @click="reset">{{ $t("message.reset") }}</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO
          </li>
          <!-- 选择 -->
          <li class="flex05">{{ $t("message.choose") }}</li>
          <!--  店铺信息-->
          <!-- <li class="flex15">
            {{ $t("message.storeInformation") }}
          </li> -->
          <!--照片-->
          <li>{{ $t("message.pic") }}</li>
          <!-- 业务编辑商品属性 -->
          <li class="flex15">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
          <!-- 附加服务  -->
          <li class="flex2">{{ $t("message.additionalServices") }}</li>
          <!-- 业务报价 -->
          <li>{{ $t("message.businessOffer") }}</li>
          <!-- 入金后数量 -->
          <li>{{ $t("message.amountAfterGol") }}</li>
          <!-- 入金后价格 -->
          <li>{{ $t("message.priceAfterEntryIntoGold") }}</li>
          <!-- 问题类别  -->
          <li>{{ $t("message.typeOfProblem") }}</li>
          <!-- 问题数 -->
          <li>{{ $t("message.numberOfProblems") }}</li>
          <!-- 问题图片 -->
          <li class="flex2">{{ $t("message.problemPic") }}</li>
          <!-- 修改后数据 -->
          <li class="flex2">{{ $t("message.modifiedData") }}</li>
          <!-- 退款金额凭证 -->
          <li>{{ $t("message.refundAmountVoucher") }}</li>
          <!-- 业务的商品备注  -->
          <li class="flex2">{{ $t("message.businessCommodityNotes") }}</li>
          <!-- 问题描述  -->
          <li class="flex2">{{ $t("message.problemDescription") }}</li>
          <!-- 业务翻译(给客户) -->
          <li class="flex2 important">
            {{ $t("message.businessTranslationUser") }}
          </li>
          <!-- 客户回复 -->
          <li class="flex2 important">{{ $t("message.userReply") }}</li>
          <!-- 业务决策 -->
          <li class="flex2">{{ $t("message.businessDecisionsRemark") }}</li>
          <!-- 采购处理 -->
          <li class="flex2">{{ $t("message.procurementProcessRemark") }}</li>
          <!-- 问题状态 -->
          <li>{{ $t("message.status") }}</li>
          <!-- 操作 -->
          <li v-if="userRole == 2">{{ $t("message.operation") }}</li>
        </ol>
        <!-- 订单详情 -->
        <div class="detail" v-for="(item, index) in list" :key="index">
          <!-- 订单层 -->
          <div class="head">
            <div class="inco" @click="isListShow(index)">
              <i class="el-icon-arrow-up" v-if="item.show"></i>
              <i class="el-icon-arrow-right" v-else></i>
            </div>
            <!-- 提出时间 -->
            <div class="item">
              <div>
                <p>{{ $t("message.forwardTime") }}</p>
                {{ item.created_at }}
              </div>
            </div>
            <!-- 客户付款时间 -->
            <div class="item">
              <div>
                <p>{{ $t("message.customerPaymentTime") }}</p>
                {{ item.datetime_pay_confirm }}
              </div>
            </div>
            <!-- 订单 -->
            <div class="item order">
              <div>
                <p>
                  <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank">{{ item.order_sn
                  }}</router-link>
                  <!-- 同订单搜索 -->
                  <el-button size="mini" type="primary" style="margin-left: 10px;"
                    @click="sameOrderSearch(item.order_sn)">
                    {{ $t('message.sameOrderSearch') }}
                  </el-button>
                  <el-popover placement="top-start" trigger="hover" width="260"
                    :content="item.client_notice[0].notice_content" v-if='item.client_notice != false'>
                    <span slot="reference" class="problem">问</span>
                  </el-popover>
                </p>
                <span style="display: inline-block;height: 22px;width: 70px;vertical-align: middle;">
                  <attributeName :name="item.attribute_name" />
                </span>
                <router-link
                  :to="'/user/basicInformation?userID=' + item.user_id + '&encryption=' + $md5(item.user_id + '')"
                  target="_blank">
                  {{ item.realname }}
                </router-link>

                <i class="el-icon-copy-document" @click="copy(item.order_sn)"></i>
              </div>
              <!-- 分批付款 -->
              <div style="margin-left: 10px; color: #fff;padding: 5px;border-radius: 4px;"
                :style="{ background: item.part_pay_status <= 4 ? '#DFC881' : 'rgb(21, 173, 60)' }"
                v-if="item.part_pay_status">
                {{ item.part_pay_status_name }}
              </div>
            </div>
            <!-- 业务 -->
            <div class="item name">
              {{ $t("message.business") }}:{{ item.y_realname }}
            </div>
            <!-- 采购 -->
            <div class="item name">
              {{ $t("message.purchase") }}:{{ item.g_realname }}
            </div>
            <!-- 配货 -->
            <div class="item ">
              {{ $t("message.distribution") }}:{{ item.p_realname }}
            </div>
            <!--提出人： -->
            <div class="item">
              {{ $t("message.peoplePutForward") }}:
              {{ item.created_admin }}
            </div>
            <!-- RAKUCHAT图标： -->
            <div class="item order">
              <a :href="'https://www.chatwork.com/#!rid' + item.chatwork" target="_blank" v-if="item.chatwork"> <img
                  src="@/assets/user/CW.svg" alt="" style="vertical-align: middle;">
                chatwork</a>
              <span style="cursor: pointer;" @click="chat(item)" v-else> <img src="@/assets/user/raku.svg" alt=""
                  style="vertical-align: middle;">
                RAKUCHAT</span>
              <!-- 生成链接 -->
              <el-button type="primary" size="small" style="margin-left: 15px;"
                @click="copy('https://www.rakumart.com/issueOrderDetail?order_sn=' + item.order_sn)">
                {{ $t('message.generateLink') }}
              </el-button>
              <!-- 发送邮件 -->
              <el-button type="primary" size="small" style="margin-left: 15px;" @click="sendingEmails(item)">
                {{ $t('message.sendingEmails') }}
              </el-button>
            </div>
          </div>
          <!-- 交易号层 -->
          <div class="groupByPurchaseNo" v-for="(groupByPurchaseNo, groupByPurchaseNoIndex) in item.groupByPurchaseNo"
            :key="groupByPurchaseNoIndex">
            <!-- 交易号号 -->
            <div class="trading" v-if="item.show">
              <el-checkbox v-model="groupByPurchaseNo.checked" @change="purchase_noAll(index, groupByPurchaseNoIndex)"
                style="margin-right: 30px;"></el-checkbox>
              {{ $t("message.transactionNumber") }} :
              <span v-if="groupByPurchaseNo.purchase_no">
                <a :href="'https://trade.1688.com/order/new_step_order_detail.htm?orderId=' + groupByPurchaseNo.purchase_no"
                  target="_blank">
                  {{ groupByPurchaseNo.purchase_no }}</a>
                <i class="el-icon-copy-document" @click="copy(groupByPurchaseNo.purchase_no)"></i>
              </span>
              <span v-else> ———— </span>
                <!-- 781：查看采购返现收款，入口和金额状态共用查看权限。 -->
              <template v-if="isAuth(781)">
                <span class="cashback-entry">
                  <el-button type="success" size="mini" class="cashback-button" :disabled="!groupByPurchaseNo.purchase_no"
                    @click="$refs.purchaseCashbackList.open(groupByPurchaseNo.purchase_no)">
                    {{ $t('message.cashbackCollectionLink') }}
                  </el-button>
                  <!-- 全部已作废时隐藏摘要，明细弹框仍保留全部记录。 -->
                  <span v-if="groupByPurchaseNo.cashbackEntry.latest" class="cashback-latest"
                    :class="{ paid: groupByPurchaseNo.cashbackEntry.latest.status === 'paid', pending: groupByPurchaseNo.cashbackEntry.latest.status === 'pending' }">
                    {{ groupByPurchaseNo.cashbackEntry.latest.amount }} {{ groupByPurchaseNo.cashbackEntry.latest.status_name }}
                  </span>
                </span>
              </template>
              <!-- 合道电子商务 -->
              <span class="item">合道电子商务</span>

              <span class="item prompt" v-if="groupByPurchaseNo.same_purchase_no >= 2">注意有同一交易号商品等待处理</span>
              <!-- 新增紧急件 -->
              <div class="urgent">
                <!-- 查询当前交易号对应的换货返件单号 -->
                <el-button type="primary" size="small" :disabled="!groupByPurchaseNo.purchase_no"
                  @click="openExchangeReturnTrackingNumber(groupByPurchaseNo.purchase_no)">
                  {{ $t('message.addReplacementReturnTrackingNumber') }}
                </el-button>
                <!-- 新增物流号 -->
                <el-button type="primary" size="small" @click="logisticsNumberAdded(groupByPurchaseNo.list)">
                  {{ $t('message.logisticsNumberAdded') }}
                </el-button>
                <el-button type="primary" size="small" @click="newEmergency">
                  {{ $t('message.newEmergency') }}
                </el-button>
              </div>
            </div>
            <template v-if="item.show">
              <ul v-for="(items, indexs) in groupByPurchaseNo.list" :key="indexs">
                <li class="flex05">
                  {{ items.sorting }}
                  <span v-if="items.is_repeted" class="chong">重</span>
                </li>
                <!-- 选择 -->
                <li class="flex05">
                  <label>
                    <el-popover placement="right" title="合计" width="200" trigger="focus">
                      <statistics :checkList="checkList" />
                      <el-checkbox v-model="items.checked" @change="radioItem" slot="reference"></el-checkbox>
                    </el-popover>
                  </label>
                </li>
                <!--  店铺信息-->
                <!-- <li class="flex15">
                  <div>
                    <p>{{ items.shop_name }}</p>
                    <p>{{ items.from_platform }}</p>
                    <p>{{ items.shop_id }}</p>
                  </div>
                </li> -->
                <!--照片-->
                <li>
                  <div class="img">
                    <el-popover placement="right" width="300" trigger="hover">
                      <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                      <a :href="items.link" target="_blank" slot="reference">
                        <img :src="items.pic" alt="" />
                      </a>
                    </el-popover>

                    <p class="client-sku-code">
                  {{ items.for_sn }}
                    </p>
                      <div v-if="items.replace_goods_info">
                      <div class="replace_goods_info" @click="replaceGoodsInfo(items.replace_goods_info)">替换</div>
                    </div>
                  </div>
                </li>
                <!-- 商品属性 -->
                <li class="flex15">
                  <div class="template">
                    <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex"
                      @click="detail_y_copy(items.detail_y)">
                      <span>{{ skuItem.key }}:</span>
                      <span>{{ skuItem.value }}</span>
                    </p>

                  </div>
                </li>
                <!--附加服务  -->
                <li class="flex2">
                  <el-popover placement="bottom-start" width="400" trigger="click" v-if="items.option">
                    <el-table :data="items.option" border size="mini" show-summary>
                      <el-table-column property="name" label="附加服务" align="center"></el-table-column>
                      <el-table-column property="num" label="数量" align="center"></el-table-column>
                      <el-table-column label="单价" align="center">
                        <template slot-scope="scope">
                          {{ scope.row.price }} {{ scope.row.unit }}
                        </template>
                      </el-table-column>
                      <el-table-column label="小计.元" align="center" property="total">
                      </el-table-column>
                    </el-table>
                    <div class="template" slot="reference">
                      <div v-for="(opti, optis) in items.option" :key="opti.id" style="color: #2c96e7;">
                        <p>{{ optis + 1 }}, {{ opti.name }} * {{ opti.num }}x{{ opti.price }} {{ opti.unit }}</p>
                      </div>
                    </div>
                  </el-popover>
                </li>
                <!--业务报价 -->
                <li>
                  <div class="template">
                    <!-- 数量 -->
                    <p>{{ $t("message.number") }}:{{ items.offer_num_bak }}</p>
                    <!-- 价格 -->
                    <p>{{ $t("message.price") }}:{{ items.offer_price_bak }}</p>
                    <!-- 运费-->
                    <p>
                      {{ $t("message.freight") }}:{{ items.offer_freight_bak }}
                    </p>
                  </div>
                </li>
                <!-- 入金后数量 -->
                <li>
                  <div class="template">
                    <!-- 可入库 -->
                    <p>
                      {{ $t("message.canBePutIntoStorage") }}:{{ items.possible_num ? items.possible_num : "——" }}
                    </p>
                    <!-- 已到货 -->
                    <p>
                      {{ $t("message.itHasArrived") }}:{{ items.storage_num ? items.storage_num : "——" }}
                    </p>
                    <!-- 已出货 -->
                    <p>
                      {{ $t("message.hasBeenShipped") }}:{{ items.p_num ? items.p_num : "——" }}
                    </p>
                  </div>
                </li>
                <!-- 入金后价格 -->
                <li>
                  <div class="template">
                    <!-- 价格 -->
                    <p>{{ $t("message.unitPrice") }}:{{ items.price }}</p>
                    <!-- 运费-->
                    <p>{{ $t("message.freight") }}:{{ items.freight }}</p>
                  </div>
                </li>
                <!--问题类别  -->
                <li>{{ items.type_name }}</li>
                <!-- 问题产品数 -->
                <li>
                  {{ items.num }}
                </li>
                <!-- 问题图片 -->
                <li class="flex2">
                  <div class="imgList">
                    <div class="imgs" v-for="(imgs, imgIndex) in items.problem_goods_image" :key="imgIndex">
                      <div class="index">
                        {{ imgIndex + 1 }}
                      </div>
                      <el-image v-if="imgs.image"
                        :src="imgs.isOss ? imgs.image + '?x-oss-process=image/resize,p_10' : imgs.image"
                        :preview-src-list="[imgs.image]">
                      </el-image>
                      <img src="@/assets/icon/eye.png" alt="" class="el-icon-open" v-if="imgs.client_show">

                      <!-- <img class="avatar"
                        @click="handlePictureCardPreview(imgs.image)" /> -->
                    </div>
                  </div>
                </li>
                <!-- 修改后数据 -->
                <li class="flex2">
                  <div class="template">
                    <!-- 修改后数量 -->
                    <p :class="{ difference: items.pre_num != items.possible_num }"
                      v-if="items.pre_num != items.possible_num">
                      {{ $t("message.editNumber") }}: {{ items.pre_num }}
                    </p>
                    <!-- 修改后单价 -->
                    <p :class="{ difference: items.pre_price != items.offer_price_bak }"
                      v-if="items.pre_price != items.offer_price_bak">{{ $t("message.editPrice") }}.元:
                      {{ items.pre_price }}
                    </p>
                    <!-- 修改后运费 -->
                    <p :class="{ difference: items.pre_freight != items.offer_freight_bak }"
                      v-if="items.pre_freight != items.offer_freight_bak">
                      {{ $t("message.editFreight") }}.元: {{ items.pre_freight }}
                    </p>
                    <el-popover placement="bottom-start" width="400" trigger="click"
                      v-if="items.option_new && items.option_new != false">
                      <el-table :data="items.option_new" border size="mini" show-summary>
                        <el-table-column property="name" label="附加服务" align="center"></el-table-column>
                        <el-table-column property="num" label="数量" align="center"></el-table-column>
                        <el-table-column label="单价" align="center">
                          <template slot-scope="scope">
                            {{ scope.row.price }} {{ scope.row.unit }}
                          </template>
                        </el-table-column>
                        <el-table-column label="小计.元" align="center" property="total">
                        </el-table-column>
                      </el-table>
                      <div class="template" slot="reference">
                        <div v-for="(opti, optis) in items.option_new" :key="opti.id">
                          <p class="difference">
                            {{ optis + 1 }}, {{ opti.name }} * {{ opti.num }}x{{ opti.price }}{{ opti.unit }}
                          </p>
                        </div>
                        <el-button type="primary" size="mini">{{ $t('message.detail') }}</el-button>
                      </div>
                    </el-popover>
                  </div>
                </li>
                <!-- 退款金额凭证 -->
                <li @click="setProblem_goods_id(items.problem_goods_id)">
                  <div>
                    <el-image v-if="items.refund_image" :src="items.refund_image"
                      :preview-src-list="[items.refund_image]">
                    </el-image>
                    <!-- 编辑 -->
                    <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'"
                      :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                      v-if="items.refund_status != 10 && isAuth(687)">
                      <el-button type="text">{{ $t('message.redact') }}</el-button>
                    </el-upload>
                  </div>
                </li>
                <!-- 业务的商品备注  -->
                <li class="flex2">{{ items.y_remark }}</li>
                <!-- 具体问题描述 -->
                <li class="flex2 remark-border">
                  {{ items.description }}
                </li>
                <!-- 业务翻译 -->
                <li class="flex2 remark-border">
                  {{ items.description_translate }}
                </li>
                <!-- 客户回复 -->
                <li class="flex2 remark-border">
                  {{ items.client_deal }}
                </li>
                <!-- 业务决策 -->
                <li class="flex2 remark-border">
                  {{ items.y_deal }}
                </li>
                <!-- 采购处理 -->
                <li class="flex2 remark-border" style="  border-right: 1px solid #ccc;">
                  {{ items.g_deal }}
                </li>
                <!-- 问题状态 -->
                <li>
                  <div class="template">
                    <p>
                      <el-popover placement="left" width="400" height="800" trigger="click">
                        <div style="padding: 0 12px">
                          <h6 style="height: 40px;line-height: 40px;margin-bottom: 10px; ">
                            单番时间点
                          </h6>
                          <el-timeline>
                            <el-timeline-item :color="node.datetime ? '#2C96E7' : ''" size="large"
                              v-for="(node, nodeIndex) in node_list" :key="nodeIndex" v-show="node.datetime != '此节点暂无'"
                              style="padding-bottom: 5px;">
                              {{ `${node.name}: ${node.datetime != null ? node.datetime : ''}` }}
                            </el-timeline-item>
                          </el-timeline>
                        </div>
                        <el-button type="text" size="mini" slot="reference"
                          :style="{ color: getColor(items.product_status_name) }" @click="getSortingTimeNode(items)">
                          {{ items.product_status_name }}
                        </el-button>
                      </el-popover>
                    </p>
                    <el-popover placement="left" width="280" trigger="click">
                      <h6 style="margin: 10px 0">问题产品时间点：</h6>
                      <el-timeline>
                        <!-- 问题提出 -->
                        <el-timeline-item>
                          {{ $t("message.problemPropose") }}：
                          {{ items.created_at }}
                        </el-timeline-item>
                        <!-- 业务翻译 -->
                        <el-timeline-item>
                          {{ $t("message.businessTranslationUser") }}：
                          {{ items.translate_at }}
                        </el-timeline-item>
                        <!-- 客户回复 -->
                        <el-timeline-item>
                          {{ $t("message.userReply") }}：
                          {{ items.client_deal_at }}
                        </el-timeline-item>
                        <!--业务决策  -->
                        <el-timeline-item>
                          {{ $t("message.businessDecisions") }}：
                          {{ items.y_deal_at }}
                        </el-timeline-item>
                        <!-- 采购处理 -->
                        <el-timeline-item>
                          {{ $t("message.procurementProcess") }}：
                          {{ items.g_deal_at }}
                        </el-timeline-item>
                        <!-- 配货确认 -->
                        <el-timeline-item>
                          {{ $t("message.distributionProcessed") }}：
                          {{ items.p_deal_at }}
                        </el-timeline-item>
                      </el-timeline>
                      <span slot="reference" style="color: #2c96e7">
                        问：{{ items.status_name }}</span>
                    </el-popover>
                    <p>
                      <!-- 检品状态 -->
                      <el-button type="text" @click="lookInspectionList(items)" size="mini">
                        {{ $t('message.inspectionStatus') }}
                      </el-button>
                    </p>
                    <p style="color: rgb(250, 80, 88);" v-if="userRole == 2 && datas.refund_status">采：
                      {{ items.refund_status_name }}
                    </p>
                    <p>
                      <span slot="reference" style="color: #2c96e7" v-if="item.user_id == '1868'"
                        @click="label1868Print(item, groupByPurchaseNo, items)">
                        退货标签
                      </span>
                    </p>
                  </div>
                </li>
                <!-- 操作 -->
                <li v-if="userRole == 2">
                  <!-- 审核 -->
                  <el-button type="primary" size="mini" v-if="items.refund_status == 1 && datas.refund_status"
                    @click="confirmRefundStatus(items.problem_goods_id)">{{ $t("message.examine")
                    }}</el-button>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="datas.status != 6 ? [20, 50, 80, 100, 200] : [20]" :page-size="datas.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>

      </div>
      <!-- 操作 -->
      <div class="operation">
        <!-- 全选 -->
        <el-checkbox v-model="checked" @change="allChecked">
          {{ $t("message.allChecked") }}
        </el-checkbox>
        <!-- 同ID商品 -->
        <el-button type="primary" size="small" @click="productWithTheSameId" class="primary">
          {{ $t("message.productWithTheSameId") }}
        </el-button>
        <!-- 同店铺商品 -->
        <el-button type="primary" size="small" @click="sameStoreProduct" class="primary">
          {{ $t("message.sameStoreProduct") }}
        </el-button>
        <!-- 复制商品信息 -->
        <el-button type="primary" size="small" @click="copyText" class="primary">
          {{ $t("message.copyProductInformation") }}
        </el-button>
        <!-- 问题产品取消 -->
        <el-button type="primary" size="small" @click="problemCancel(1)" class="dark" v-if="isAuth(212)">
          {{ $t("message.problemProductCancellation") }}
        </el-button>
        <!-- 重提问题产品 -->
        <el-button type="primary" size="small" @click="rehashTheProblemProduct(6)" class="primary" v-if="isAuth(171)">
          {{ $t("message.rehashTheProblemProduct") }}
        </el-button>
        <!-- 附加服务修改 -->
        <el-button type="primary" size="small" @click="editOption" class="primary" v-if="isAuth(217)">
          {{ $t("message.editAdditionalServices") }}
        </el-button>
        <!-- 数量价格运费修改 -->
        <el-button type="primary" size="small" @click="quantityPriceFreightModification" class="primary"
          v-if="isAuth(213)">
          {{ $t("message.quantityPriceFreightModification") }}
        </el-button>
        <!-- 退回待业务决策 -->
        <el-button type="primary" size="small" @click="returnToPendingBusinessDecision(4)" class="primary">
          {{ $t("message.returnToPendingBusinessDecision") }}
        </el-button>
        <!-- 产品退换货 -->
        <el-button type="primary" size="small" @click="productReturnAndExchange" class="dark" v-if="isAuth(284)">
          {{ $t("message.productReturnAndExchange") }}
        </el-button>
        <!-- 业务直接完成 -->
        <!-- <el-button
          type="primary"
          size="small"
          class="fr"
          @click="skipToComplete"
          >{{ $t("message.directBusinessCompletion") }}</el-button
        > -->
        <!-- 配货直接完成 -->
        <el-button type="primary" size="small" class="fr" @click="distributionDirectComplete" v-if="isAuth(219)">
          {{ $t("message.directCompletion") }}
        </el-button>
        <!-- 确认完成 -->
        <el-button type="primary" size="small" class="fr" @click="confirmCompletion" v-if="isAuth(219)">
          {{ $t("message.confirmCompletion") }}
        </el-button>
        <!-- 采购处理 -->
        <el-button type="primary" size="small" class="fr primary" @click="procurementProcess(4)" v-if="isAuth(218)">
          {{ $t("message.procurementProcess") }}
        </el-button>
        <!-- 业务决策 -->
        <el-button type="primary" size="small" class="fr primary" @click="businessDecisions(3)" v-if="isAuth(215)">
          {{ $t("message.businessDecisions") }}
        </el-button>
        <!-- 业务翻译 -->
        <el-button type="primary" size="small" class="fr primary" @click="businessTranslation(1)" v-if="isAuth(214)">
          {{ $t("message.businessTranslationUser") }}
        </el-button>
        <!-- 临时备注 -->
        <el-button type="primary" size="small" class="fr primary" @click="temporaryRemarks" v-if="isAuth(220)">
          {{ $t("message.temporaryRemarks") }}
        </el-button>
        <!-- 退回待翻译 -->
        <el-button type="primary" size="small" class="fr primary" @click="returnToTranslation" v-if="isAuth(478)">
          {{ $t("message.returnToTranslation") }}
        </el-button>
      </div>
    </div>
    <!-- 数量价格运费修改 -->
    <quantityPriceFreightModification v-if="quantityPriceFreightModificationDialogVisible" :itemsData="itemsData" />
    <!--  业务翻译-->
    <businessTranslation v-if="businessTranslationDialogVisible" :disposeList="disposeList" />
    <!-- 业务决策 -->
    <businessDecisions v-if="businessDecisionsDialogVisible" :disposeList="disposeList" @refresh="refresh" />
    <!-- 采购处理 -->
    <procurementProcess ref="procurementProcess" />
    <!-- 附加服务 -->
    <editOptions v-if="optionsDialogVisible" :option="optionsList" :itemsData="itemsData" :checkList="checkList" />
    <!-- 问题产品 -->
    <problemStore />
    <!-- 产品退换货 -->
    <productReturnAndExchange :list="checkList" :showCancelButton="true" ref="productReturnAndExchange" />
    <!--  临时备注-->
    <temporaryRemarks :list="checkList" v-if="temporaryRemarksDialogVisible" />
    <!-- 检品状态详情 -->
    <inspectionList :order_purchase_id="order_purchase_id" ref="inspectionList" />
    <!-- 紧急件 -->
    <urgent ref="urgent" />
    <!-- 换货返件单号 -->
    <exchangeReturnTrackingNumber ref="exchangeReturnTrackingNumber" />
    <!-- 采购返现收款链接列表 -->
    <purchaseCashbackList ref="purchaseCashbackList" @latest-change="updateCashbackLatest" />
    <!-- 添加物流号 -->
    <addExpress v-if="addExpressDialogVisible" :ids="selectedIDs" />
    <!-- 替换商品链接 -->
    <replaceLink ref="replaceLink" />
    <!-- 退货标签 -->
    <returnLabel ref="returnLabel" />
    <!-- 查看大图 -->
    <el-dialog :visible.sync="picDialogVisible" width="500px">
      <img :src="dialogImageUrl" alt="" style="width: 100%;" />
    </el-dialog>
  </div>
</template>
<script>
import Head from "@/components/header/detailHeader.vue";
import businessTranslation from "./components/businessTranslation";
import procurementProcess from "./components/procurementProcess";
import editOptions from "./components/editOptions.vue";
import quantityPriceFreightModification from "./components/quantityPriceFreightModification";
import businessDecisions from "./components/businessDecisions";
import problemStore from "@/components/problemStore/store/index";
import productReturnAndExchange from "./components/productReturnAndExchange";
import temporaryRemarks from "./components/temporaryRemarks";
import inspectionList from './components/inspectionList'
import statistics from './components/statistics'
import urgent from '@/components/common/urgent'
import exchangeReturnTrackingNumber from './components/exchangeReturnTrackingNumber'
import purchaseCashbackList from './components/purchaseCashbackList'
import addExpress from "../orderDetail/components/addExpress";
import replaceLink from '@/components/common/replaceLink'
import returnLabel from '../inspectDetail/components/returnLabel'
import { vipList, g_deal_type } from '../../utlis/options'
import { getColor } from "@/utlis/utlis";
export default {
  metaInfo: {
    title: "售前问题",
  },
  components: {
    Head,
    editOptions,
    businessTranslation,
    procurementProcess,
    quantityPriceFreightModification,
    businessDecisions,
    problemStore,
    productReturnAndExchange,
    temporaryRemarks,
    inspectionList,
    statistics,
    urgent,
    exchangeReturnTrackingNumber,
    purchaseCashbackList,
    addExpress,
    replaceLink,
    returnLabel
  },
  data() {
    return {
      vipList,
      g_deal_type,
      tabsList: [],
      datas: {
        status: "0",
        page: 1,
        pageSize: 20,
        dateStart: "",
        dateEnd: "",
        express_no: "",
        refund_express_no: "",
        purchase_no: "",
        order_sn: this.$route.query.order_sn,
        client_sku_code: "",
        user_id: "",
        org_id: "",
        admin_id: "",
        overdue: '',
      },
      problem_goods_id: '',
      loading: false,//上传图片用
      userList: [],
      total: 0,
      //列表数据
      list: [],
      orderDetailsInfo: null,
      checked: false,
      //选择中的订单
      checkList: [],
      disposeList: [], //处理的交易号订单
      //修改option
      optionsDialogVisible: false,
      optionsList: [],
      itemsData: {},
      // 订单处理
      dialogImageUrl: "",
      picDialogVisible: false,
      itemDetail: [],
      //   业务翻译
      businessTranslationDialogVisible: false,
      //   采购处理
      procurementProcessDialogVisible: false,
      // 数量价格运费修改
      quantityPriceFreightModificationDialogVisible: false,
      //   业务决策
      businessDecisionsDialogVisible: false,
      //产品退换货
      productReturnAndExchangeDialogVisible: false,
      // 临时备注
      temporaryRemarksDialogVisible: false,
      // 新增物流号
      addExpressDialogVisible: false,
      selectedIDs: [], //选中的商品ID
      order_purchase_id: 0,//检品状态详情
      userRole: localStorage.getItem('japanUserRoleStatus'), //工种
      node_list: [],// 时间节点
      getColor,
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
    problemTypes() {
      return this.$store.state.problemTypes;
    },
  },
  created() {
    this.$store.dispatch("getOrganizationList");
    this.$api.problemApi.statusMap().then((res) => {
      this.tabsList = res.data;
      this.tabsList.unshift({
        id: 0,
        name: "全部状态"
      })
    });
    let query = this.$route.query
    if (query.status) {
      this.datas.status = query.status
    }
    if (query.overdue) {
      this.datas.overdue = query.overdue
    }
    if (query.user_id) {
      this.datas.user_id = query.user_id
    }
    // 判断工种
    if (this.userRole == 1) { // 业务默认翻译
      this.datas.status = '1'
    } else if (this.userRole == 2) { // 采购默认待采购处理
      this.datas.status = '4'
    } else if (this.userRole == 5) { // 配货默认待配货处理
      this.datas.status = '5'
    }
    if (query.status) {
      this.datas.status = query.status
    }
    this.problemList();
  },
  methods: {
    problemList() {
      this.checked = false;
      if (this.datas.status == 6) {
        this.datas.pageSize = 20
      }
      this.$api.problemApi.problemList(this.datas).then((res) => {
        this.orderDetailsInfo = res.data.orderInfo;
        this.total = res.data.total;
        // 同一交易号在多个订单中共用摘要，收集后统一批量查询。
        const cashbackQueries = new Map()
        // 计算option 总价
        res.data.data.forEach((item) => {
          item.show = true;
          item.checked = false
          item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
            groupByPurchaseNo.checked = false
            // 收款模块仅按采购交易号查询，每个交易号只保留一个入口和摘要。
            const purchaseNo = groupByPurchaseNo.purchase_no ? String(groupByPurchaseNo.purchase_no) : ''
            if (!cashbackQueries.has(purchaseNo)) {
              cashbackQueries.set(purchaseNo, { purchase_no: purchaseNo, latest: null, requestId: 0 })
            }
            groupByPurchaseNo.cashbackEntry = cashbackQueries.get(purchaseNo)
            groupByPurchaseNo.list.forEach((items) => {
              // 退换货用
              items.order_purchase_refund_detail_express = [];
              items.checked = false;
              //   给修改option用
              items.total = items.pre_num * items.pre_price;
              if (items.option) {
                items.option.forEach((optin, index) => {
                  if (optin.price_type == 1) {
                    optin.total =
                      (optin.price / 100) *
                      items.offer_price_bak *
                      optin.num
                  } else {
                    optin.total = optin.num * optin.price
                  }
                  optin.total = optin.total.toFixed(2)
                });
              }
              if (items.option_new) {
                items.option_new.forEach((optin, index) => {
                  if (optin.price_type == 1) {
                    optin.total =
                      (optin.price / 100) *
                      items.offer_price_bak *
                      optin.num
                  } else {
                    optin.total = optin.num * optin.price
                  }
                  optin.total = optin.total.toFixed(2)
                });
              }
              // 查找图片是否是阿里云的
              items.problem_goods_image.forEach(imgs => {
                if (imgs.image.indexOf('rakumart-ps20') != -1 || imgs.image.indexOf('raku-ai') != -1 || imgs.image.indexOf('rakumart-image') != -1) {
                  imgs.isOss = true
                } else {
                  imgs.isOss = false
                }

              })
            });
          });
        });
        this.list = res.data.data;
        this.loadCashbackLatest(Array.from(cashbackQueries.values()))
        console.log(res);
      });
      this.problemGoodsListNum()
    },
    // 交易号以字符串数组一次提交，按返回记录的purchase_no分别回填摘要。
    async loadCashbackLatest(entries) {
      if (!this.isAuth(781)) return
      const requests = entries.filter(entry => entry.purchase_no).map(entry => {
        entry.latest = null
        return { entry, requestId: ++entry.requestId }
      })
      if (!requests.length) return
      try {
        const res = await this.$api.problemApi.purchaseCashbackList({
          purchase_no: [...new Set(requests.map(({ entry }) => entry.purchase_no))],
          page: 1,
          pageSize: 100,
        })
        if (res.code !== 0) return
        const recordsByPurchaseNo = new Map()
        res.data.list.forEach(record => {
          const purchaseNo = String(record.purchase_no)
          if (!recordsByPurchaseNo.has(purchaseNo)) recordsByPurchaseNo.set(purchaseNo, [])
          recordsByPurchaseNo.get(purchaseNo).push(record)
        })
        requests.forEach(({ entry, requestId }) => {
          // 弹框更新摘要后，忽略同一交易号较早的批量响应。
          if (entry.requestId !== requestId) return
          const records = recordsByPurchaseNo.get(entry.purchase_no) || []
          if (records.some(record => record.status !== 'voided')) entry.latest = records[0]
        })
      } catch (error) {
        // 查询失败时不展示金额，错误提示沿用公共请求层。
      }
    },
    // 弹框更新后仅收集对应交易号的摘要，仍通过一次批量请求刷新。
    updateCashbackLatest({ purchase_no }) {
      const entries = new Set()
      this.list.forEach(order => {
        order.groupByPurchaseNo.forEach(group => {
          if (group.cashbackEntry.purchase_no === purchase_no) entries.add(group.cashbackEntry)
        })
      })
      this.loadCashbackLatest(Array.from(entries))
    },
    //数量统计
    problemGoodsListNum() {
      this.$api.tabTotalApi.problemGoodsListNum().then(res => {
        this.tabsList.forEach(item => {
          res.data.forEach(items => {
            if (item.name == items.tabName) {
              item.name = item.name + `(${items.num})`
            }
          })
        })
      })
    },
    // 搜索
    search() {
      this.datas.page = 1
      if (this.datas.status) {
        this.datas.refund_status = ''
      }
      this.problemList();
    },
    // 重置
    reset() {
      this.datas = {
        status: "0",
        page: 1,
        pageSize: 20,
        dateStart: "",
        dateEnd: "",
        express_no: "",
        refund_express_no: "",
        purchase_no: "",
        order_sn: "",
        client_sku_code: "",
        user_id: "",
        org_id: "",
        admin_id: "",
        refund_status: '',
        attribute: '',
        refund_image: '',
        g_deal_type: '',
      };
      this.$refs.cascader.orgId = [];
      this.problemList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.problemList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.problemList();
    },
    // 是否显示商品列表
    isListShow(i) {
      this.list[i].show = !this.list[i].show;
      this.$forceUpdate();
    },
    // 单选
    radioItem() {
      this.checkList = [];
      this.list.forEach((item) => {
        item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
          groupByPurchaseNo.list.forEach((items) => {
            if (items.checked) {
              items.purchase_no = groupByPurchaseNo.purchase_no;
              this.checkList.push(items);
            }
          });
          groupByPurchaseNo.checked = groupByPurchaseNo.list.every(items => items.checked)
        });
      });
      this.$forceUpdate();
    },
    //订单全选
    purchase_noAll(index, groupByPurchaseNoIndex) {
      this.checkList = [];
      this.list[index].groupByPurchaseNo[groupByPurchaseNoIndex].list.forEach((item) => {
        item.checked = this.list[index].groupByPurchaseNo[groupByPurchaseNoIndex].checked
        if (item.checked) {
          item.purchase_no = this.list[index].groupByPurchaseNo[groupByPurchaseNoIndex].purchase_no;
          this.checkList.push(item);
        }
      })
      this.list.forEach(item => {
        item.checked = item.groupByPurchaseNo.every(items => items.checked)
      })
      this.checked = this.list.every(item => item.checked)
      this.$forceUpdate()
    },
    //  全选
    allChecked() {
      this.checkList = [];
      this.list.forEach((item) => {
        item.checked = this.checked;
        item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
          groupByPurchaseNo.checked = this.checked;
          groupByPurchaseNo.list.forEach((items) => {
            items.checked = this.checked;
            if (items.checked) {
              items.purchase_no = groupByPurchaseNo.purchase_no;
              this.checkList.push(items);
            }
          });
        });
      });
      this.$forceUpdate();
    },
    // 同id的商品
    productWithTheSameId() {
      let ids = [];
      this.list.forEach((item) => {
        item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
          groupByPurchaseNo.list.forEach((items) => {
            if (items.checked) {
              ids.push(items.goods_id);
            }
          });
        });
      });
      this.list.forEach((item) => {
        item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
          groupByPurchaseNo.list.forEach((items) => {
            ids.forEach((id) => {
              if (id == items.goods_id) {
                items.checked = true;
              }
            });
          });
        });
      });
      this.$forceUpdate();
    },
    // 同店铺的商品
    sameStoreProduct() {
      let ids = [];
      this.list.forEach((item) => {
        item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
          groupByPurchaseNo.list.forEach((items) => {
            if (items.checked) {
              ids.push(items.shop_id);
            }
          });
        });
      });
      this.list.forEach((item) => {
        item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
          groupByPurchaseNo.list.forEach((items) => {
            ids.forEach((id) => {
              if (id == items.shop_id) {
                items.checked = true;
              }
            });
          });
        });
      });
      this.$forceUpdate();
    },
    // 点击修改option
    editOption() {
      if (this.checkList == false) return this.$message.error("未选择问题产品");
      if (this.checkList[0].status > 3)
        return this.$message.error("业务已经决策完了，不能修改");
      let itemData = JSON.parse(JSON.stringify(this.checkList[0]))
      this.optionsList = itemData.option_new ? itemData.option_new :
        itemData.option
      this.itemsData = itemData
      this.optionsDialogVisible = true;
    },
    // 成功修改option
    successOption(option) {
      this.problemList();
      this.optionsDialogVisible = false;
    },
    // 业务翻译
    businessTranslation(status) {
      this.changeCheckList();
      this.businessTranslationDialogVisible = true;
    },
    //采购处理
    procurementProcess(status) {
      this.changeCheckList();
      this.$refs.procurementProcess.dialogVisible = true
    },
    //确认完成
    confirmCompletion() {
      this.$confirm(
        this.$t("message.confirmCompletion"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            data: [],
          };
          this.list.forEach((item) => {
            item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
              groupByPurchaseNo.list.forEach((items) => {
                if (items.checked) {
                  datas.data.push({ problem_goods_id: items.problem_goods_id });
                }
              });
            });
          });
          this.$api.problemApi.p_deal(datas).then((res) => {
            if (res.code != 0) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.problemList();
          });
        })
        .catch(() => { });
    },
    // 业务直接完成
    skipToComplete() {
      this.$confirm(
        this.$t("message.confirmdirectBusinessCompletion"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            data: [],
          };
          this.list.forEach((item) => {
            item.list.forEach((items) => {
              if (items.checked) {
                datas.data.push({ problem_goods_id: items.problem_goods_id });
              }
            });
          });
          this.$api.problemApi.skipToComplete(datas).then((res) => {
            if (res.code != 0) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.problemList();
          });
        })
        .catch(() => { });
    },
    // 选择中的订单
    changeCheckList() {
      this.checkList = [];
      this.disposeList = [];
      this.list.forEach((item) => {
        let list;
        item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
          //   筛选出list中选择中的list
          list = JSON.parse(
            JSON.stringify(
              groupByPurchaseNo.list.filter((items) => items.checked)
            )
          );
          // 给list每一项添加需要操作的数据
          list.forEach((items) => {
            items.problem_goods_image.forEach(images => {
              images.checked = images.client_show ? true : false
            })
            items.content_f = "";
            items.content_y = items.y_deal
            items.content_g = "";
            if(!items.service_deal_suggest){
              items.service_deal_suggest = items.type == 4 || items.type == 9 ? '1' : "2";
            }else{
              items.service_deal_suggest = items.service_deal_suggest + '';
            }
            if(!items.option_deal_suggest){
              items.option_deal_suggest = items.option_new ? "1" : '2';
            }else{
              items.option_deal_suggest = items.option_deal_suggest + '';
            }
           
            //   items.freight = items.freight;
            items.editNum = items.pre_num;
            items.editPrice = items.pre_price;
            items.editFreight = items.pre_freight;
            items.checked = false;
            items.is_purchase_add = items.is_purchase_add == 1 ? true : false;
          });
          // 创建要处理的数据
          this.disposeList.push({
            purchase_no: groupByPurchaseNo.purchase_no,
            list: list,
            order_sn: item.order_sn,
            created_admin_work_type: item.created_admin_work_type
          });
          groupByPurchaseNo.list.forEach((items) => {
            if (items.checked) {
              items.order_sn = item.order_sn
              this.checkList.push(items);
            }
          });
        });
      });
      // 筛选出没有list里么有数据的
      this.disposeList = this.disposeList.filter((item) => item.list != false);
    },
    // 查看大图
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.picDialogVisible = true;
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    // 修改后数据编辑
    quantityPriceFreightModification() {
      if (this.checkList == false) return this.$message.error("未选择问题产品");
      if (this.checkList.length > 1)
        return this.$message.error("只能选择一个问题产品修改后数据编辑");
      this.itemsData = this.checkList[0];
      this.quantityPriceFreightModificationDialogVisible = true;
    },
    //业务决策
    businessDecisions(status) {
      this.changeCheckList();
      this.businessDecisionsDialogVisible = true;
    },
    // 退回待业务决策
    returnToPendingBusinessDecision(status) {
      this.$confirm(
        this.$t("message.isReturnToPendingBusinessDecision"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            data: [],
          };
          this.list.forEach((item) => {
            item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
              groupByPurchaseNo.list.forEach((items) => {
                if (items.checked) {
                  datas.data.push({ problem_goods_id: items.problem_goods_id });
                }
              });
            });
          });
          this.$api.problemApi.backToYdeal(datas).then((res) => {
            if (res.code != 0) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.problemList();
          });
        })
        .catch(() => { });
    },
    //产品退换货
    productReturnAndExchange() {
      this.changeCheckList();
      if (this.checkList == false) return this.$message.error("请选择订单");
      this.$refs.productReturnAndExchange.dialogVisible = true;
    },
    //临时备注
    temporaryRemarks() {
      this.changeCheckList();
      if (this.checkList == false) return this.$message.error("请选择订单");
      this.temporaryRemarksDialogVisible = true;
    },
    // 重提问题产品
    rehashTheProblemProduct(status) {
      this.changeCheckList();
      let datas = {
        order_purchase_id: [],
        inspect_detail_id: [],
      };
      this.checkList.forEach((item) => {
        datas.order_purchase_id.push(item.order_purchase_id);
      });
      //   if (order_sn.length > 1)
      //     return this.$message.error(this.$t("message.danGeDanDingDan"));
      this.$store.dispatch("getProblemList", datas);
      this.checked = false;
      this.allChecked();
    },
    // 问题产品提交成功
    problemStoreSuccess() {
      this.problemList();
    },
    //问题产品取消
    problemCancel(status) {
      this.$confirm(
        this.$t("message.isProblemProductCancellation"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            problem_goods_id: [],
          };
          this.list.forEach((item) => {
            item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
              groupByPurchaseNo.list.forEach((items) => {
                if (items.checked) {
                  datas.problem_goods_id.push(items.problem_goods_id);
                }
              });
            });
          });
          this.$api.problemApi.problemCancel(datas).then((res) => {
            if (res.code != 0) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.problemList();
          });
        })
        .catch(() => { });
    },
    //查看检品状态详情
    lookInspectionList(item) {
      this.order_purchase_id = item.order_purchase_id
      this.$refs.inspectionList.dialogVisible = true
    },
    //复制选择商品信息
    copyText() {
      this.changeCheckList();
      if (this.checkList === 0) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      let copyUrl = "";
      this.checkList.forEach((item) => {
        if (this.userRole == 2) { //采购工种特殊
          let size = ''
          item.detail_y.forEach((items, indexs) => {
            size += `${items.key}: ${items.value} \n`
          })
          copyUrl += `${size}数量:${item.possible_num}\n订单番号:${item.order_sn}\n商品番号:${item.sorting}\n链接:${item.link}交易号: ${item.purchase_no}\n`
        } else {
          copyUrl += `注文番号：${item.order_sn}\n${item.sorting}番  ${item.link}\n交易号: ${item.purchase_no}\n`
          // item.order_purchase_express.forEach((items, indexs) => {
          //   copyUrl += `物流号: ${items.express_no}\n`
          // })
        }

      });
      this.copy(copyUrl)
    },
    //退回待翻译
    returnToTranslation() {
      this.$confirm(
        this.$t("message.isBackToWaitTranslate"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            problem_goods_id_set: [],
          };
          this.list.forEach((item) => {
            item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
              groupByPurchaseNo.list.forEach((items) => {
                if (items.checked) {
                  datas.problem_goods_id_set.push(items.problem_goods_id);
                }
              });
            });
          });
          this.$api.problemApi.toUnTranslate(datas).then((res) => {
            if (res.code != 0) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.problemList();
          });
        })
        .catch(() => { });
    },
    //新增紧急件
    newEmergency() {
      this.$refs.urgent.dalogVisible = true
    },
    // 打开换货返件单号弹窗，purchase_no 使用当前交易号分组编号
    openExchangeReturnTrackingNumber(purchaseNo) {
      this.$refs.exchangeReturnTrackingNumber.open(purchaseNo)
    },
    //新增物流号
    logisticsNumberAdded(list) {
      this.selectedIDs = []
      list.forEach(item => {
        this.selectedIDs.push(item.order_purchase_id)
      })
      this.addExpressDialogVisible = true
    },
    // 新增完物流号
    wuliuSuccess() {
      this.addExpressDialogVisible = false
    },
    //打开聊天
    chat(item) {
      let japanUserRoleInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo'))
      let token = localStorage.getItem('japan_access_token')
      let iTop = (window.screen.availHeight - 30 - 700) / 2;
      //获得窗口的水平位置
      let iLeft = (window.screen.availWidth - 10 - 1260) / 2;
      if (location.host.indexOf('.co.jp') == -1) {
        window.open(
          `https://rakuchat.rakumart.com/admin_web/#/?id=JP${japanUserRoleInfo.id}&uid=${item.user_id}&token=${token}`,
          japanUserRoleInfo,
          "height=700, width=1260, left=" +
          iLeft +
          ", top=" +
          iTop +
          ", toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no"
        );
      }
    },
    // 同订单搜索
    sameOrderSearch(order) {
      this.datas.order_sn = order
      this.problemList();
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      this.loading = true
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
        this.loading = false
      }
      return isJPG || isPNG || isSVG;
    },
    // 上传所需索引
    setProblem_goods_id(problem_goods_id) {
      this.problem_goods_id = problem_goods_id
    },
    //上传成功
    handleAvatarSuccess(file) {
      let datas = {
        problem_goods_id: this.problem_goods_id,
        refund_image: file.data
      }
      this.loading = false
      this.$api.problemApi.updateRefundImage(datas).then((res) => {
        this.list.forEach((item) => {
          item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
            groupByPurchaseNo.list.forEach((items) => {
              if (items.problem_goods_id == this.problem_goods_id) {
                items.refund_image = file.data
              }
            });
          });
        });
        this.$message.success(res.msg);
        this.$forceUpdate()
      });

    },
    // 采购审核
    procurementReview(status) {
      this.datas.refund_status = status
      this.datas.status = ''
      this.datas.page = 1
      this.search()
    },
    // 问题产品-审核
    confirmRefundStatus(problem_goods_id) {
      let datas = {
        problem_goods_id: [problem_goods_id]
      }
      this.$api.problemApi.confirmRefundStatus(datas).then((res) => {
        this.$message.success(res.msg);
        this.problemList();
      });
    },
    //发送邮件
    sendingEmails(item) {
      let datas = {
        problem_goods_id: [],
      }
      item.groupByPurchaseNo.forEach(groupByPurchaseNo => {
        groupByPurchaseNo.list.forEach(goods => {
          if (goods.checked) {
            datas.problem_goods_id.push(goods.problem_goods_id)
          }
        })
      })
      if (datas.problem_goods_id == false) return this.$message.error(this.$t('message.selectableOperational'))
      this.$confirm(
        '确定要给客户发送邮件提醒？',
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.problemApi.problemWaitClient(datas).then((res) => {
            this.$message.success(res.msg);
          });
        })
        .catch(() => { });

    },
    //时间点
    getSortingTimeNode(item) {
      let datas = {
        order_detail_id_set: [item.order_detail_id]
      }

      this.node_list = []
      this.$api.orderApi.getSortingTimeNode(datas).then(res => {
        this.node_list = res.data[0].node_list
        console.log(res);
      })

    },
    // 刷新数据
    refresh(replace_goods_info) {
      // console.log(replace_goods_info, 123);
      this.list.forEach((item) => {
        item.groupByPurchaseNo.forEach((groupByPurchaseNo) => {
          groupByPurchaseNo.list.forEach((items) => {
            if (items.problem_goods_id == replace_goods_info.new.problem_goods_id) {
              items.replace_goods_info = replace_goods_info
            }
          });
        });
      });
      this.$forceUpdate()
    },
    // 替换商品信息
    replaceGoodsInfo(replace_goods_info) {
      this.$refs.replaceLink.replace_goods_info = replace_goods_info
      this.$refs.replaceLink.dialogVisible = true
    },
    // 复制商品属性
    detail_y_copy(detail_y) {
      let str = ''
      detail_y.forEach(item => {
        str += `${item.key}: ${item.value}\n`
      })
      this.copy(str)
    },

    // 1868标签打印
    label1868Print(item, groupByPurchaseNo, items) {
      let labelData = {
        sorting: items.sorting,
        detail_y: items.detail_y,
        order_sn: items.order_sn,
        order_detail_tag: items.order_detail_tag != null ? items.order_detail_tag[0] : '',
        confirm_num: items.pre_num,
        inspectNum: '',
        type: '',
        g_name: item.g_realname,
        p_name: item.p_realname,
        y_name: item.y_realname,
        purchase_no: groupByPurchaseNo.purchase_no,
        order_purchase_express: items.order_purchase_express != false ? items.order_purchase_express[0].express_no : '',
      }

      if (items.order_detail_tag == '') {
        return this.$message.error(
          '请选择有标的商品'
        );
      }
      // 取detail_y的第一个值
      let type = items.detail_y != false ? items.detail_y[0].value : ''
      if (type.includes('／')) {
        labelData.type = type.split('／')[0]
      }
      // 没有检测类型时，取detail_y的第一个值
      if (labelData.type == '') {
        type = items.detail_y != false ? items.detail_y[1].value : ''
        if (type.includes('／')) {
          labelData.type = type.split('／')[0]
        }
      }
      this.$refs.returnLabel.labelData = labelData
      this.$refs.returnLabel.dialogVisible = true
    },
    // 配货直接完成
    distributionDirectComplete() {
      this.changeCheckList();
      let datas = {
        preview_bill: 0,
        problem_goods_id_set: []
      }
      if (this.checkList.length == 0) return this.$message.error(this.$t('message.selectableOperational'))
      this.checkList.forEach((item) => {
        datas.problem_goods_id_set.push(item.problem_goods_id);
      });
      this.checkList.every(item => item.checked)
      if (!this.checkList.every(item => item.status == 4)) return this.$message.error('请选择待采购处理状态的商品进行操作完成')

      this.$confirm(
        process.env.NODE_ENV !== 'production' ? '生死有命富贵在天，是否确认？' : '是否直接跳过采购问题产品完成，确认后出入金将发生变更，请确认后再进行操作',
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.$api.problemApi.distributionDirectComplete(datas).then((res) => {
          this.$message.success(res.msg);
          this.problemList();
        });
      }).catch(() => { });

    }
  },
};
</script>
<style lang='scss' scoped>
// @import "@/css/mixin.scss";
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.body {
  padding: 20px 20px 120px;
  min-width: 1872px;

  .search {
    margin: 20px 0;
    display: grid;
    grid-template-columns: repeat(10, minmax(0, 1fr));
    column-gap: 20px;

    .Container {
      /deep/.el-date-editor,
      .el-select {
        width: 100%;
      }

      /deep/.el-cascader {
        width: 100%;
      }
    }


  }

  .tabs {
    // background-color: #f5f5f5;
    margin-bottom: 20px;
    position: relative;

    .btn {
      position: absolute;
      top: 0;
      right: 0;
    }

    /deep/.el-tabs__header {
      margin: 0;
    }
  }

  .table {
    ol {
      display: flex;
      font-size: 14px;
      height: 40px;
      background: #edeff4;
      color: #333;
      position: sticky !important;
      top: 0;
      left: 0;
      z-index: 999;
    }

    ul {
      display: flex;
      border-bottom: 1px solid #e8e8e8;
      padding: 10px 0;
      font-size: 12px;
      transition: 0.25s;

      &:hover {
        background-color: #eee;
        cursor: pointer;
      }

      li {
        width: 100%;
        overflow: hidden;
        //   max-height: 80px;

        .template {
          text-align: left;
          width: 100%;
          max-height: 120px;

          p {
            line-height: 20px;
          }
        }

        .scope {
          max-height: 100px;

          p {
            line-height: 20px;
          }
        }

        .imgList {
          display: flex;
          flex-wrap: wrap;

          .imgs {
            margin: 0 10px 10px 0;
            position: relative;
            height: 50px;

            .index {
              position: absolute;
              top: -0px;
              left: -0px;
              width: 15px;
              height: 15px;
              background-color: #B4272D;
              border-radius: 50%;
              text-align: center;
              line-height: 15px;
              color: #fff;
              z-index: 99;
            }

            .el-icon-open {
              position: absolute;
              bottom: 0px;
              right: 0;
              width: 18px;
              padding: 0;
            }

            &:nth-child(even) {
              margin-right: 0;
            }

            &:nth-child(n + 2) {
              margin-bottom: 0;
            }


          }
        }
      }



      .img {
        img {
          width: 60px;
          height: 60px;
          border-radius: 4px;
        }

        .client-sku-code {
          margin-top: 4px;
          font-size: 12px;
          line-height: 16px;
          word-break: break-all;
        }
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0 3px;

      label {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .el-image {
        height: 50px;
        width: 50px;
        border-radius: 4px;
      }
    }

    .flex05 {
      flex: 0.5;
      position: relative;

      .chong {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        text-align: center;
        line-height: 25px;
        color: #fff;
        position: absolute;
        top: 50%;
        left: 20px;
        background-color: #2C96E7;
      }
    }

    .flex15 {
      flex: 1.3;
    }

    .flex2 {
      flex: 1.8;
    }

    .remark-border {
      border: 1px solid #ccc;
      border-right: 0;
      display: block;
      text-align: left;
      word-break: break-all;
    }

    .important {
      background-color: #fee0c3;
    }

    .detail {

      .head {
        height: 50px;
        display: flex;
        background: #7080b1;
        font-size: 14px;
        padding: 0 20px;
        color: #fff;
        margin: 5px 0;

        .inco {
          margin-right: 24px;
          display: flex;
          align-items: center;
          font-size: 20px;
          cursor: pointer;
        }

        .item {
          display: flex;
          align-items: center;
          flex: 1;
          line-height: 20px;
        }

        .order {
          flex: 2.2;
        }

        .name {
          flex: 0.7;
          margin-left: 24px;
        }

        a {
          color: #fff;

          &:hover {
            text-decoration: underline;
          }
        }

        .problem {
          display: inline-block;
          width: 28px;
          height: 28px;
          background-color: #B4272D;
          vertical-align: middle;
          text-align: center;
          line-height: 28px;
          border-radius: 50%;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }

    .noData {
      padding: 20px 0;
      text-align: center;
    }

    .trading {
      padding: 12px;
      background-color: #dedeef;
      color: #000;
      position: relative;

      .cashback-entry {
        display: inline-flex;
        align-items: center;
        margin-left: 12px;
        gap: 10px;

        .cashback-button,
        .cashback-latest {
          margin-left: 0;
        }

        .cashback-latest {
          color: #909399;

          &.paid {
            color: #67C23A;
          }

          &.pending {
            color: #F56C6C;
          }
        }
      }

      a {
        color: #000;
      }

      span {
        margin-left: 20px;
      }

      .urgent {
        position: absolute;
        top: 5px;
        right: 5px;
      }

      .prompt {
        color: #B4272D;
        font-size: 20px;
        font-weight: 600;
      }
    }


  }

  .operation {
    position: sticky !important;
    left: 50%;
    bottom: 0;
    z-index: 999;
    margin-top: 20px;
    background-color: #edeff4;
    padding: 10px 24px;
    min-width: 1802px;
    border-radius: 5px 5px 0 0;

    // transform: translate(-50%, 0);
    .el-button {
      margin-left: 12px;
    }
  }
}

/deep/.el-dialog {
  margin-top: 50px !important;
}

.difference {
  color: #B4272D
}

.replace_goods_info {
  width: 60px;
  height: 25px;
  background-color: #B4272D;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-radius: 10px;
}
</style>
